import React from "react";
import { Container, Grid, Box } from "@mui/material";
import "../styles/Section1.css";
import VideoChatRoundedIcon from "@mui/icons-material/VideoChatRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import CurrencyExchangeRoundedIcon from "@mui/icons-material/CurrencyExchangeRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";

const Features = () => {
  const featuresList = [
    {
      icon: <VideoChatRoundedIcon sx={{ fontSize: 26 }} />,
      title: "24/7 Virtual Consultations",
      description:
        "Connect with general physicians, pediatricians, and specialists across Nigeria via secure HD video, voice, or chat.",
    },
    {
      icon: <AccountBalanceWalletRoundedIcon sx={{ fontSize: 26 }} />,
      title: "Integrated Health Wallet",
      description:
        "Manage all your healthcare payments in one place. Fund your balance easily in Naira (₦) with cards or instant bank transfers.",
    },
    {
      icon: <CurrencyExchangeRoundedIcon sx={{ fontSize: 26 }} />,
      title: "Instant Refund Guarantee",
      description:
        "No hassle and no delays. If a doctor is delayed or an appointment is rescheduled, your consultation fee is refunded instantly.",
    },
    {
      icon: <VerifiedRoundedIcon sx={{ fontSize: 26 }} />,
      title: "NIN-Verified Practitioners",
      description:
        "Every medical expert is vetted using their National Identification Number (NIN) and certified medical board licenses.",
    },
    {
      icon: <ReceiptLongRoundedIcon sx={{ fontSize: 26 }} />,
      title: "Digital Prescriptions (Rx)",
      description:
        "Receive electronically signed clinical prescriptions and test referrals right on your phone immediately after your session.",
    },
    {
      icon: <SecurityRoundedIcon sx={{ fontSize: 26 }} />,
      title: "Encrypted & Confidential",
      description:
        "Your clinical history and consultation recordings are protected by bank-level end-to-end encryption protocols.",
    },
  ];

  return (
    <Box className="feature-section-wrap">
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} lg={4}>
            <span className="feature-tag">Why Choose Telemedicine</span>
            <h2 className="feature-title">
              Healthcare built around your convenience and budget.
            </h2>
            <p className="feature-lead">
              We combine world-class clinical expertise with effortless financial
              transparency so you never have to delay your wellbeing.
            </p>
          </Grid>

          <Grid item xs={12} lg={8}>
            <Grid container spacing={3}>
              {featuresList.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <div className="feature-card">
                    <div className="f-icon-box">{item.icon}</div>
                    <div className="feature-name">{item.title}</div>
                    <div className="feature-description">{item.description}</div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Features;
